import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ReshapeRectangleAction extends AbstractProvidedClass {
    constructor(provider, elementPart) {
        super(provider);

        this.elementPart = elementPart;
        this.parent = elementPart.parent;

        this.oldCorners = this.parent.corners.map(c => [c.absX, c.absY]);
        this.oldParentAbsX = this.parent.absX;
        this.oldParentAbsY = this.parent.absY;

        if (this.settings.snapToGrid) {
            this.prevX = this.view.currentX;
            this.prevY = this.view.currentY;
        }
    }

    update() {
        if (this.settings.snapToGrid && !this.parent.isOnAxis) {
            let shiftX = this.calculateShift(this.prevX, this.view.currentX);
            let shiftY = this.calculateShift(this.prevY, this.view.currentY);

            if (shiftX == 0 && shiftY == 0) {
                return;
            }

            this.prevX += shiftX;
            this.prevY += shiftY;
        }
        this.elementPart.drag();
    }

    finish() {
        this.newCorners = this.parent.corners.map(c => [c.absX, c.absY]);
        this.newParentAbsX = this.parent.absX;
        this.newParentAbsY = this.parent.absY;

        if (this.newParentAbsX == this.oldParentAbsX
            && this.newParentAbsY == this.oldParentAbsY
        ) {
            this.actions.discard();
        } else {
            this.actions.finish();
        }
    }

    undo() {
        for (let i = 0; i < 4; i++) {
            let c = this.parent.corners[i];
            c.absX = this.oldCorners[i][0];
            c.absY = this.oldCorners[i][1];
        }
        this.parent.absX = this.oldParentAbsX;
        this.parent.absY = this.oldParentAbsY;

        this.updateDisplay();
    }

    redo() {
        for (let i = 0; i < 4; i++) {
            let c = this.parent.corners[i];
            c.absX = this.newCorners[i][0];
            c.absY = this.newCorners[i][1];
        }
        this.parent.absX = this.newParentAbsX;
        this.parent.absY = this.newParentAbsY;

        this.updateDisplay();
    }

    private

    updateDisplay() {
        this.parent.row.updateImg();
        this.getTab('info').input.width.value(this.calculatePixelToDisplayDistance(this.parent.width));
        this.getTab('info').input.height.value(this.calculatePixelToDisplayDistance(this.parent.height));
    }

    calculateShift(prevPos, currentPos) {
        let step = (currentPos - prevPos) / this.grid.minorSize;

        if (Math.abs(step) < 1) {
            return 0;
        }

        step = step > 0 ? Math.floor(step) : Math.ceil(step);
        return step * this.grid.minorSize;
    }
}
